import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  TextField,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  Pagination,
  Skeleton,
  FormControlLabel,
  styled,
  Switch,
  Modal,
  Paper,
  Grid,
  Divider,
  DialogContent,
  Dialog,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import ContactPopup from "../components/ViewDetails";
import { colors, fonts, size } from "../ColorFont/color";
import { useTranslation } from "react-i18next";
import Carousel from "react-material-ui-carousel";
import { CitySelect, StateSelect } from "react-country-state-city";
import {
  Call,
  Close,
  Favorite,
  FavoriteBorder,
  GetApp,
  SubdirectoryArrowRight,
  VisibilityOff,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import { url } from "../ConstUrl/Url";
import SignUp from "../auth/SignUp";
import { useNavigate } from "react-router-dom";
import UnifiedCropCard from "../components/UnifiedCropCard";
import CropDetailsModal from "../components/CropDetailsModal";
import { toast } from "react-toastify";
import FilterDialog from "../components/common/FilterDialog";
import { IconAdjustmentsHorizontal } from "@tabler/icons-react";

const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
      borderRadius: 22 / 2,
      "&::before, &::after": {
        content: '""',
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: 16,
        height: 16,
      },
      "&::before": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
        left: 12,
      },
      "&::after": {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
          theme.palette.getContrastText(theme.palette.primary.main)
        )}" d="M19,13H5V11H19V13Z" /></svg>')`,
        right: 12,
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "none",
      width: 16,
      height: 16,
      margin: 2,
    },
}));

const Search = ({ userData, keyword, setUserData }) => {
  const navigate = useNavigate();
  const userId = userData?._id;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  const [plots, setPlots] = useState([]);
  const [filterCategory, setFilterCategory] = useState([]);
  const [state, setState] = useState("");
  const [tehsil, setTehsil] = useState("");
  const [page, setPage] = useState(1);
  const [sortBy, setSortBy] = useState("");
  const [isSeller, setIsSeller] = useState(false);
  const [isBuyer, setIsBuyer] = useState(false);
  const [pageData, setPageData] = useState(null);
  const [countryid, setCountryid] = useState(101);
  const [stateid, setstateid] = useState(0);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [isUpgradePopupOpen, setOpenUpgradePopup] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [available, setAvailable] = useState(false);
  const [isModalClosed, setIsModalClosed] = useState(false);
  const role = userData?.role;
  const [wishlist, setWishlist] = useState(userData?.wishlist);
  const [open, setOpen] = React.useState(false);
  const [showResult, setShowResult] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(""); // Selected category
  const [subCategories, setSubCategories] = useState([]);
  const [categories, setCategories] = useState([]); // To store fetched categories
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [filterSubCategory, setFilterSubCategory] = useState([]);
  const [displayCity, setDisplayCity] = useState(false);
  const [displayCat, setDisplayCat] = useState(false);
  const [purchasedPlots, setPurchasedPlots] = useState(null);
  const [isContactPopClose, setIsContactPopClose] = useState(false);
  const [renderPage, setRenderPage] = useState(false);
  const [contactPopupClosed, setContactPopupClosed] = useState(false);
  const [openContactModal, setOpenContactModal] = useState(false);
  const [contactNumber, setContactNumber] = useState("");
  const [openLogin, setOpenLogin] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");
  const [statusClicked, setStatusClicked] = useState(false);
  const [ownPlots, setOwnPlots] = useState(false);
  const [showResultsClicked, setShowResultsClicked] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [localSearch, setLocalSearch] = useState('');
  const scrollRef = React.useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 200;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  const handleOpenDetails = (plot) => {
    setSelectedPlot(plot);
    setIsDetailsModalOpen(true);
  };

  const handleDeleteSuccess = (plotId) => {
    setPlots(plots.filter(p => p._id !== plotId));
  };

  const handleBoost = () => {
    handleSearch();
  };

  const handleEdit = (plot) => {
    navigate('/add-crop-step-1', { 
      state: { 
        isEdit: true, 
        cropId: plot._id,
        cropData: plot 
      } 
    });
  };

  const handleSearch = async () => {

    try {
      const searchTerm = localSearch || keyword || '';
      let URI = `${url}/api/plots?category=${filterCategory.join(",")}&subCategory=${filterSubCategory}&state=${state}&tehsil=${tehsil}&page=${page}&sortby=${sortBy}&search=${encodeURIComponent(searchTerm)}&disabled=false&status=${filterStatus}`;

      if (ownPlots) {
        URI += `&user=${userId}`;
      }
      const response = await fetch(URI);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setPlots(data.paginatedPlots);
      setPageData(data);
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };
  useEffect(() => {
    fetch(`${url}/api/plots?disabled=false`)
      .then((response) => response.json())
      .then((data) => setPlots(data.paginatedPlots))
      .catch((error) => console.error(error));
  }, [userData]);

  useEffect(() => {
    if (role == "Seller") {
      setIsSeller(true);
    } else if (role == "Buyer") {
      setIsBuyer(true);
    }
    handleSearch();
    if (showResultsClicked) {
      setShowResultsClicked(false);
    }
  }, [
    keyword,
    localSearch,
    filterCategory,
    filterSubCategory,
    // state,
    // tehsil,
    page,
    // sortBy
    showResult,
    isModalClosed,
    openPopup,
    isContactPopClose,
    statusClicked,
    showResultsClicked,
  ]);

  // Reset to page 1 when search term changes
  useEffect(() => {
    setPage(1);
  }, [localSearch]);

  const handleSort = (event) => {
    const {
      target: { value },
    } = event;
    setSortBy(value);
    setPage(1);
  };

  useEffect(() => {
    fetchViewedPlots();
  }, [userId, contactPopupClosed, renderPage]);

  const handleClearFilter = (event) => {
    setShowResult(true);
    setDisplayCity(false);
    setDisplayCat(false);
    setFilterCategory([]);
    setFilterSubCategory([]);
    setState("");
    setTehsil("");
    setSelectedCategory("");
    setSelectedSubCategory("");
    setPage(1);
    setstateid(0);
    setOwnPlots(false);
    setSortBy("");
    setFilterStatus("");
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  const handleCancel = () => {
    setOpen(false);
  };
  useEffect(() => {
    fetch(`${url}/api/get-categories`)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data);
      })
      .catch((error) => console.error(error));
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      const category = categories.find(
        (category) => category.categoryType === selectedCategory
      );
      if (category) {
        setSubCategories(category.subCategories || []);
      }
    }
  }, [selectedCategory]);

  const handleShowResult = () => {
    setShowResult(true);
    setShowResultsClicked(true);

    // Sync dialog states to search states
    setFilterCategory(selectedCategory ? [selectedCategory] : []);
    setFilterSubCategory(selectedSubCategory || "");
    
    // state and tehsil are already synced via props in FilterDialog
    
    setPage(1);
    setOpen(false);
  };

  const handleWishlist = (plotId) => {
    const action = wishlist?.includes(plotId) ? "remove" : "add";
    fetch(`${url}/api/wishlist`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: userData?._id,
        plotId,
        action,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (action === "add") {
          setWishlist([...wishlist, plotId]);
        } else {
          setWishlist(wishlist.filter((id) => id !== plotId));
        }
      })
      .catch((error) => console.error(error));
  };
  const handleCloseLogin = () => {
    setOpenLogin(false);
  };
  const handleOpen = () => {
    setOpenLogin(true);
  };
  useEffect(() => {
    if (userData) {
      handleCloseLogin();
    }
  }, [userId]);
  const handleGetContact = (plot) => {
    const userId = userData?._id;
    const plotId = plot?._id;

    if (!userData) {
      handleOpen();
      return;
    } else if (userData.noOfContacts <= 0) {
      // If no contacts and plot details are not already viewed, show upgrade popup
      if (userData?.role === "Seller") {
        alert("Switch to a buyer role to view plot details, contact a seller.");
        return;
      } else {
        if (
          !userData?.purchasedPlots?.some(
            (purchasedPlot) => purchasedPlot.plotId === plotId
          )
        ) {
          navigate('/buyer/boost', { state: { cropData: plot } });
          return;
        }
      }
    }

    fetch(`${url}/api/view-plot-details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId,
        plotId,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Plot details already viewed") {
          setSelectedPlot(plot);
          setOpenPopup(true);
        } else {
          // Decrement noOfContacts and update userData
          setUserData(data.user);
          setSelectedPlot(plot);
          setOpenPopup(true);
        }
      })
      .catch((error) => console.error(error));
  };

  const handleSortStatus = (event) => {
    const {
      target: { value },
    } = event;
    setStatusClicked(true);
    setPage(1);
    setFilterStatus(value);
  };

  useEffect(() => {
    fetchViewedPlots();
  }, [userId]);
  const fetchViewedPlots = () => {
    if (userId) {
      fetch(`${url}/api/purchasedPlots/${userId}`)
        .then((response) => response.json())
        .then((data) => {
          setPurchasedPlots(data.purchasedPlots);
        })
        .catch((error) =>
          console.error("Error fetching purchasedPlots:", error)
        );
    }
  };
  const handleCloseContactModal = () => {
    setOpenContactModal(false);
    setRenderPage(true);
  };
  useEffect(() => {
    if (renderPage) {
      // Render the page again
      fetchViewedPlots();
      setRenderPage(false);
    }
  }, [renderPage]);

  return (
    <Box sx={{ background: colors.background3 }}>
      <ContactPopup
        open={openPopup}
        onClose={() => {
          setIsChange(!isChange);
          setOpenPopup(false);
          setSelectedPlot(null);
        }}
        plot={selectedPlot}
      />

      {/* ── Search Bar ── */}
      <Box sx={{
        px: 0,
        pt: { xs: 2.5, md: 3 },
        pb: 1,
      }}>
        <Box sx={{
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
        }}>
          {/* Search Icon */}
          <Box sx={{
            position: 'absolute',
            left: '16px',
            display: 'flex',
            alignItems: 'center',
            color: '#919EAB',
            pointerEvents: 'none',
            zIndex: 1,
          }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8"/>
              <line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
          </Box>

          <TextField
            fullWidth
            size="small"
            placeholder={t("searchPlaceholder")}
            value={localSearch}
            onChange={(e) => setLocalSearch(e.target.value)}
            sx={{
              '& .MuiOutlinedInput-root': {
                height: '52px',
                borderRadius: '16px',
                backgroundColor: '#FFFFFF',
                fontFamily: fonts.poppins,
                fontSize: '15px',
                pl: '36px',
                '& fieldset': { borderColor: '#E0E5EB' },
                '&:hover fieldset': { borderColor: '#919EAB' },
                '&.Mui-focused fieldset': { borderColor: colors.primary, borderWidth: '1.5px' },
              },
              '& .MuiOutlinedInput-input': {
                pl: 0,
                '&::placeholder': { color: '#919EAB', opacity: 1, fontFamily: fonts.poppins },
              },
            }}
            InputProps={{
              endAdornment: localSearch ? (
                <IconButton
                  size="small"
                  onClick={() => setLocalSearch('')}
                  sx={{ mr: 0.5, color: '#919EAB', '&:hover': { color: '#1C252E' } }}
                >
                  <Close fontSize="small" />
                </IconButton>
              ) : null,
            }}
          />
        </Box>
      </Box>

      {/* ── Category Quick Filters ── */}
      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', mb: 2, mx: { xs: 0, md: -1 } }}>
        <IconButton
          size="small"
          onClick={() => scroll('left')}
          sx={{
            position: 'absolute',
            left: 0,
            zIndex: 2,
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
            '&:hover': { backgroundColor: '#F4F6F8' },
            display: { xs: 'none', md: 'flex' }
          }}
        >
          <ChevronLeft />
        </IconButton>

        <Box 
          ref={scrollRef}
          sx={{ 
            display: 'flex', 
            overflowX: 'auto', 
            gap: 1.5, 
            pb: 1,
            pt: 1,
            px: { xs: 0, md: 5 },
            width: '100%',
            '&::-webkit-scrollbar': { display: 'none' },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
          }}
        >
          <Chip
            label={t('common:all')}
            onClick={() => {
              setFilterCategory([]);
              setSelectedCategory("");
              setFilterSubCategory([]);
              setSelectedSubCategory("");
            }}
            sx={{
              fontFamily: fonts.poppins,
              fontWeight: 700,
              fontSize: '14px',
              px: 1,
              height: '42px',
              backgroundColor: filterCategory.length === 0 ? colors.primary : '#FFFFFF',
              color: filterCategory.length === 0 ? '#FFFFFF' : '#1C252E',
              border: `1.5px solid ${filterCategory.length === 0 ? colors.primary : '#E0E5EB'}`,
              '&:hover': {
                backgroundColor: filterCategory.length === 0 ? colors.primary_dark : '#F4F6F8',
              },
            }}
          />
          {categories.map((cat) => {
            const isSelected = filterCategory.includes(cat.categoryType);
            return (
              <Chip
                key={cat._id}
                label={t(`common:categories.${cat.categoryType}`)}
                onClick={() => {
                  setFilterCategory([cat.categoryType]);
                  setSelectedCategory(cat.categoryType);
                  setFilterSubCategory([]);
                  setSelectedSubCategory("");
                }}
                sx={{
                  fontFamily: fonts.poppins,
                  fontWeight: 700,
                  fontSize: '14px',
                  px: 1,
                  height: '42px',
                  backgroundColor: isSelected ? colors.primary : '#FFFFFF',
                  color: isSelected ? '#FFFFFF' : '#1C252E',
                  border: `1.5px solid ${isSelected ? colors.primary : '#E0E5EB'}`,
                  '&:hover': {
                    backgroundColor: isSelected ? colors.primary_dark : '#F4F6F8',
                  },
                }}
              />
            );
          })}
        </Box>

        <IconButton
          size="small"
          onClick={() => scroll('right')}
          sx={{
            position: 'absolute',
            right: 0,
            zIndex: 2,
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 2px 8px rgba(0,0,0,0.1)',
            '&:hover': { backgroundColor: '#F4F6F8' },
            display: { xs: 'none', md: 'flex' }
          }}
        >
          <ChevronRight />
        </IconButton>
      </Box>

      {/* ── Filter row ── */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            margin: "0px",
            gap: 2,
          }}
        >
          <Button
            variant="outlined"
            startIcon={<IconAdjustmentsHorizontal size={20} />}
            onClick={() => setOpen(true)}
            sx={{
              borderRadius: "16px",
              textTransform: "none",
              fontFamily: fonts.poppins,
              fontWeight: 700,
              fontSize: "15px",
              color: "#1C252E",
              borderColor: "#E0E5EB",
              borderWidth: "1.5px",
              backgroundColor: "#FFFFFF",
              height: "52px",
              px: { xs: 2.5, md: 4 },
              "&:hover": {
                borderColor: "#1C252E",
                backgroundColor: "#F4F6F8",
                borderWidth: "1.5px",
              },
            }}
          >
            {!isMobile && t("filter")}
          </Button>

          <FilterDialog
            open={open}
            onClose={() => setOpen(false)}
            onClear={handleClearFilter}
            onApply={handleShowResult}
            state={state}
            setState={setState}
            tehsil={tehsil}
            setTehsil={setTehsil}
            stateid={stateid}
            setstateid={setstateid}
            countryid={countryid}
            selectedCategory={selectedCategory}
            setSelectedCategory={setSelectedCategory}
            selectedSubCategory={selectedSubCategory}
            setSelectedSubCategory={setSelectedSubCategory}
            categories={categories}
            subCategories={subCategories}
            filterStatus={filterStatus}
            setFilterStatus={setFilterStatus}
            ownPlots={ownPlots}
            setOwnPlots={setOwnPlots}
            sortBy={sortBy}
            setSortBy={setSortBy}
          />
        </Box>
      </Box>
      {navigator.onLine && plots.length === 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            textAlign: "center",
            animation: "fadeIn 0.5s ease-in-out",
            height: "100vh",
          }}
        >
          <Box
            component="img"
            src="NoPlotFound.png" // Update with the correct path
            alt="No Document Found"
            sx={{ width: 250, height: "auto" }}
          />
          <Typography
            sx={{
              fontFamily: fonts.poppins,
              fontWeight: 700,
              fontSize: "24px",
            }}
          >
            {t("sorry")}
          </Typography>
          <Typography
            sx={{
              fontFamily: fonts.poppins,
              fontWeight: 400,
              color: colors.text,
              fontSize: "16px",
            }}
          >
            {t("sorryWeHaventFound")}
          </Typography>
        </Box>
      )}

      <CropDetailsModal
        open={isDetailsModalOpen}
        onClose={() => setIsDetailsModalOpen(false)}
        crop={selectedPlot}
        userData={userData}
        onGetContact={handleGetContact}
      />

      <Box sx={{ px: { xs: 2, md: 5 }, pb: 8 }}>
        {plots.length === 0 ? (
          <Grid container spacing={4} sx={{ mt: 2 }}>
            {Array.from({ length: 6 }).map((_, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Skeleton 
                  variant="rectangular" 
                  height={400} 
                  sx={{ borderRadius: "24px" }} 
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container spacing={4} sx={{ mt: 2 }}>
            {plots.map((plot) => (
              <Grid item xs={12} sm={6} md={4} key={plot._id}>
                <UnifiedCropCard
                  crop={plot}
                  userData={userData}
                  onGetContact={handleGetContact}
                  onDetails={handleOpenDetails}
                  onDeleteSuccess={handleDeleteSuccess}
                  onEdit={handleEdit}
                  onBoost={() => handleBoost(plot)}
                  isExplore={true}
                />
              </Grid>
            ))}
          </Grid>
        )}
        <Dialog
          open={openLogin}
          onClose={handleCloseLogin}
          fullWidth
          maxWidth="md"
          PaperProps={{
            sx: {
              width: isMobile ? "90%" : "50%", // Adjust width based on screen size
              maxWidth: isMobile ? "100%" : "600px", // Ensure a maximum width
              height: "auto",
              maxHeight: "90vh",
              margin: "auto",
              overflow: "auto",
              borderRadius: isMobile ? 3 : 5, // Slightly smaller border radius on mobile
              padding: isMobile ? 2 : 4, // Adjust padding for spacing
            },
          }}
        >
          {/* Close Icon Button */}
          <IconButton
            aria-label="close"
            onClick={handleCloseLogin}
            sx={{
              position: "absolute",
              right: isMobile ? 5 : 10,
              top: isMobile ? 5 : 10,
              zIndex: 1,
              color: "gray",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
              },
            }}
          >
            <Close />
          </IconButton>

          {/* Logo and Welcome Message */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              marginTop: isMobile ? 3 : 5,
            }}
          >
            <img
              src="/Icon krushisetu.png" // Update with the correct path
              alt="logo"
              style={{ width: isMobile ? 80 : 120, objectFit: 'contain' }} // Scale image size for mobile
            />
            <Typography
              sx={{
                fontFamily: fonts.poppins,
                fontWeight: 600,
                fontSize: isMobile ? 24 : 30,
                color: colors.primary_dark,
                textAlign: "center", // Center align for better mobile UI
              }}
            >
              {t("t&cWelcome")}
            </Typography>
            <Typography
              sx={{
                fontFamily: fonts.poppins,
                fontSize: isMobile ? 14 : size.subtitle,
                textAlign: "center",
              }}
            >
              {t("home-title")}
            </Typography>
          </Box>

          {/* Signup Form */}
          <DialogContent
            sx={{
              overflowY: "auto",
              maxHeight: "70vh",
              padding: isMobile ? 2 : 3,
            }}
          >
            <SignUp onClose={handleCloseLogin} />
          </DialogContent>
        </Dialog>

        <ContactPopup
          open={openPopup}
          onClose={() => {
            setIsChange(!isChange);
            setOpenPopup(false);
            setSelectedPlot(null);
          }}
          contactNumber={selectedPlot?.contactNumber}
        />
      </Box>

      {pageData?.pageCount > 1 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            margin: isMobile ? 2 : 4, // Smaller margin on mobile
          }}
        >
          <Pagination
            count={pageData?.pageCount}
            variant={isMobile ? "text" : "outlined"} // More compact on mobile
            shape="rounded"
            onChange={handleChange}
            page={page}
            size={isMobile ? "small" : "medium"} // Smaller buttons on mobile
            sx={{
              "& .MuiPaginationItem-root": {
                fontSize: isMobile ? "0.75rem" : "0.875rem", // Smaller text on mobile
                minWidth: isMobile ? 32 : 40, // Smaller buttons on mobile
                height: isMobile ? 32 : 40,
                margin: isMobile ? "0 2px" : "0 4px", // Tighter spacing on mobile
              },
              "& .MuiPaginationItem-page.Mui-selected": {
                backgroundColor: colors.primary,
                color: "#fff",
                "&:hover": {
                  backgroundColor: colors.primary_dark,
                },
              },
            }}
            showFirstButton={!isMobile} // Hide first/last buttons on mobile
            showLastButton={!isMobile}
            siblingCount={isMobile ? 0 : 1} // Show fewer page numbers on mobile
            boundaryCount={isMobile ? 1 : 2} // Show fewer boundary items on mobile
          />
        </Box>
      )}
    </Box>
  );
};

export default Search;
